import * as Action from "@actions/index";

const InitialState = {
  status: "loading",
  list: [],
  groups: [],
  error: "",
};

export default function CompanyType(state = InitialState, action: any) {
  switch (action.type) {
    case Action.Company.Type.SET_LIST:
      return { ...state, list: action.data };
    case Action.Company.Type.SET_GROUPS:
      return { ...state, groups: action.data };
    case Action.Company.Type.SET_STATUS:
      return { ...state, status: action.data };
    case Action.Company.Type.SET_ERROR:
      return { ...state, error: action.data };
    case Action.Company.Type.CLEAR:
      return { ...state, list: [] };
    default:
      return state;
  }
}
